import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, Flex, FormControl, FormLabel, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Spinner, useDisclosure, useToast } from '@chakra-ui/react'
import { useForm } from "react-hook-form";
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDoorData } from '../context/DoorContext'

import {createColumnHelper} from '@tanstack/react-table';
import { DataTable } from '../DataTable'
import { AddIcon } from '@chakra-ui/icons'
import CreateEmployeeModal from '../CreateEmployeeModal'



function DataPage() {
  
    const { user, allEmployees, getAllEmployees, loading, axiosJWT } = useDoorData()
    const navigate = useNavigate()

    const { isOpen, onOpen, onClose } = useDisclosure()
    const { isOpen: isOpenAlert, onOpen: onOpenAlert, onClose: onCloseAlert } = useDisclosure()
    const cancelRef = React.useRef()
    const { reset } = useForm();
    const [editMode, setEditMode] = useState(false);
    const [editEmployee, setEditEmployee] = useState([]);
    const [deleteEmployee, setDeleteEmployee] = useState([]);

    const toast = useToast()


    useEffect(() => {
      getAllEmployees()
  
    }, [])
  
    
  
    const handleDelete = async (userID) => {
      try {
        const res = await axiosJWT.delete(`/api/employee/delete/${userID}`)
        if (res) {
          toast({
            title: '👋 Kortelė ištrinta!',
            position: 'bottom',
            status: 'success',
            isClosable: true,
            duration: 4000
          })
          getAllEmployees();
          setDeleteEmployee([]);
          onCloseAlert();
  
        }
  
      } catch (err) {
        console.log(err.response.data);
        toast({
          title: err.response.data,
          position: 'bottom',
          status: 'error',
          isClosable: true,
          duration: 4000
        })
      }
    }



  type EmployeeList = {
    id: string,
    name: string,
    surname: string,
    cardno: string,
    group: string,
    groupname: string,
    actions: string,
  }

  const columnHelper = createColumnHelper<EmployeeList>();

  const columns = [
    columnHelper.accessor('id', {
      cell: (info) => info.getValue(),
      header: 'ID'
    }),
    columnHelper.accessor('name', {
      cell: (info) => info.getValue(),
      header: 'Vardas'
    }),
    columnHelper.accessor('surname', {
      cell: (info) => info.getValue(),
      header: 'Pavarde'
    }),
    columnHelper.accessor('cardno', {
      cell: (info) => info.getValue(),
      header: 'Korteles Nr.'
    }),
    columnHelper.accessor('group', {
      cell: (info) => info.getValue(),
      header: 'Grupė'
    }),
    columnHelper.accessor('actions', {
      cell: (info) => info.getValue(),
      header: 'Veiksmai'
    }),
  ]


  const data : any[] = 

  allEmployees.map((row : EmployeeList) => (
      
      { id : row.id.toString(),
       name:  row.name,
       surname: row.surname,
       cardno: row.cardno,
       group: row.groupname
      
       }
        
    )
      
    )

    useEffect(() => {
        if(!user) {
          navigate("/login");
        }
      }, [user])

      useEffect(() => {
        getAllEmployees();
      },[])


  return (
    <>
    {loading ? <Flex w={'90vw'} alignItems={'center'} justifyContent={'center'}><Spinner
    thickness='4px'
    speed='0.65s'
    emptyColor='gray.200'
    color='green.500'
    size='xl'
  /></Flex> : 
    <>
    <Button maxW={'12rem'} mx={'1rem'} leftIcon={<AddIcon />} onClick={() => { reset(); setEditEmployee([]); setEditMode(false); onOpen(); }} colorScheme={'blue'}>Pridėti kortelę</Button>
    <DataTable columns={columns} data={data} name={'hide'} editMode={setEditMode} onEdit={setEditEmployee} onDelete={setDeleteEmployee} onOpen={onOpen} onOpenAlert={onOpenAlert} /> 

                </>
        }

        <CreateEmployeeModal onlyCreate={false} onOpen={onOpen} isOpen={isOpen} onClose={onClose} editMode={editMode} 
        editEmployee={editEmployee} setEditEmployee={setEditEmployee} />

      <AlertDialog
        isCentered
        isOpen={isOpenAlert}
        leastDestructiveRef={cancelRef}
        onClose={onCloseAlert}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              [{deleteEmployee}] Ištrinti kortelę?
            </AlertDialogHeader>

            <AlertDialogBody>
              Ar jūs įsitikinę? Šios kortelės įrašo susigrąžinti nebegalėsite.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onCloseAlert}>
                Atšaukti
              </Button>
              <Button colorScheme='red' onClick={() => handleDelete(deleteEmployee)} ml={3}>
                Ištrinti
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    
    </>
  )
}

export default DataPage